import { Component, OnInit, EventEmitter, Input, Output, Inject, LOCALE_ID } from '@angular/core';
import { formatDate } from '@angular/common';
import { AbstractControl, FormGroup, FormControl, ValidationErrors, Validators } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton'; // Ensure this is imported
import { DialogModule } from 'primeng/dialog';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { DatePickerModule } from 'primeng/datepicker';

import moment from 'moment';

import { RequisitionIntakeDataService } from '../../data-services/requisitionIntake.service';
import { MedTek21DataService } from '../../data-services/medtek21.service';
import { BillingDataService } from '../../data-services/billing.service';
import { SecurityService } from '../../security/security.service';

import { RequisitionDto } from '../../models/requisition-dto';
import { ReqICD10Dto } from '../../models/requisition-icd10-dto';
import { ReqBillingDto, ReqBillingClaimLogDto } from '../../models/requisition-billing-dto';
import { PrepayDto, SaveEmailDto, SavePhoneDto, ClientInstBillDto, SavePreAuthDto, ClaimSubmissionDto } from '../../models/prepay-dto';
import { RequisitionStatusHistoryDto } from '../../models/requisition-status-history-dto';
import { ActiveLabPanelDto } from '../../models/active-panel-dto';
import { CodeDescription } from '../../models/code-description-dto';
import { Gender } from '../../models/gender';
import { Ethnicity } from '../../models/ethnicity';
import { Race } from '../../models/race';
import { Dialog } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { HasClaimDirective } from '../../security/has-claim.directive';

@Component({
  selector: 'billing-detail',
  templateUrl: './billing.detail.html',
  styleUrls: ['./billing.detail.css'],
  providers: [MessageService, ConfirmationService],
  imports: [Dialog, FormsModule, ConfirmDialog, DatePickerModule, Toast, CommonModule, TableModule, ReactiveFormsModule, HasClaimDirective, RadioButtonModule]
})
export class BillingDetailComponent implements OnInit {

  @Output() updatedBillingStatus = new EventEmitter<ReqBillingDto>();

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private requisitionIntakeService: RequisitionIntakeDataService,
    private medtek21Service: MedTek21DataService,
    private billingService: BillingDataService,
    private messageService: MessageService,
    public dialogModule: DialogModule,
    public securityService: SecurityService) {
  }

  @Input() requisitionId: any = 28;


  loading: boolean = true;
  carrierSearch: string = "";
  carrierCount: any = 0;
  carriers: any = [];
  pay: any = {};
  notes: BillingNote[];
  clonedNotes: { [s: string]: BillingNote } = {};
  editingRowKeys: { [s: string]: boolean } = {};
  editingRow: boolean = false;
  billingStatusThatCanBeHeld: string[] = [];

  clientInstBillSettings: ClientInstBillDto = {};
  showExpressPayDialog: boolean = false;
  showPaymentDialog: boolean = false;
  showStatusHistory: boolean = false;
  showEmailDialog: boolean = false;
  showPhoneDialog: boolean = false;
  showBillingDialog: boolean = false;
  showInstBillDialog: boolean = false;
  showClaimLogDialog: boolean = false;
  showAppealDialog: boolean = false;
  isInsuranceBill: boolean = false;

  showSendToADMButton: boolean = false;
  enableSendToADMButton: boolean = false;
  sentToADMErrors: any = [];
  showExpressPayButton: boolean = false;
  showBillOptionButton: boolean = false;

  reload: boolean = false;
  saveEmailDto: SaveEmailDto;
  savePhoneDto: SavePhoneDto;
  currentEmail: any = "";
  currentPhone: any = "";
  emailEditForm: FormGroup;
  phoneEditForm: FormGroup;
  payEditForm: FormGroup;
  billEditForm: FormGroup;
  expressPayEditForm: FormGroup;
  instBillForm: FormGroup;

  showPreAuthDialog: boolean = false;
  currentPreAuth: any = "";
  preAuthEditForm: FormGroup;
  savePreAuthDto: SavePreAuthDto;
  saveClaimSubmissionDto: ClaimSubmissionDto;
  minAppealDate: Date;
  lastInsuranceCode: any = "";
  lastInsuranceName: any = "";
  canSubmitAppeal: boolean = false;

  claimLogEditForm: FormGroup;
  appealEditForm: FormGroup;

  minDateValue: Date;
  maxDateValue: Date = new Date();

  loadingRTSH: boolean = true;
  requisition: RequisitionDto;
  requisitionStatusHistoryList: RequisitionStatusHistoryDto[] = [];
  expressPayDto: PrepayDto;

  order: any = {};
  orderNotFound: any = "";
  medtekOrder: any = {}

  reqStatusDate: string;
  reqStatusReceived: string;
  editRequisitionFlag = false;
  disableRequisitionEdit = false;
  labPanelData: ActiveLabPanelDto = null;
  rejectionLevel: any = null;
  rejectRequisitionTestId: number = null;
  canUpdate: boolean = true;

  genderList: CodeDescription[] = [];
  genderDto: Gender;
  genderDescription: string;

  ethnicityList: CodeDescription[] = [];
  ethnicity: Ethnicity;
  ethnicityDescription: string;

  raceList: CodeDescription[] = [];
  race: Race;
  raceDescription: string;

  appealSubStatusList: any[] = [
    { label: 'Appeal Denied', value: 'Appeal Denied' },
    { label: 'Submitted Appeal', value: 'Submitted Appeal' },
    { label: 'Submitted MR To Insurance', value: 'Submitted MR To Insurance' },
  ]

  activityList: any[] = [
    { label: 'Claim Submitted', value: 'CS' },
    { label: 'Claim Response', value: 'CR' },
    { label: 'Appeal Filed', value: 'AP' },
  ]


  ngOnInit() {
    var d = new Date();
    d.setDate(d.getDate() - 3);
    this.minDateValue = d;
    this.billingStatusThatCanBeHeld = [
      "Pre Billing",
      "Invoice Pending",
      "Charge Created",
      "Billing Hold",
      "Not Billable"
    ];
    this.editingRowKeys = {};

    this.emailEditForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$"), this.nowhitespace]),
    });
    this.emailEditForm.get('email').setValue("");
    this.phoneEditForm = new FormGroup({
      phone: new FormControl('', Validators.required),
    });
    this.preAuthEditForm = new FormGroup({
      preAuthCode: new FormControl('', [Validators.required]),
    });

    this.claimLogEditForm = new FormGroup({
      activityCode: new FormControl('', [Validators.required]),
      activity: new FormControl('', [Validators.required]),
      activityDate: new FormControl('', [Validators.required]),
      amount: new FormControl('', [Validators.required]),
      insuranceCode: new FormControl('', [Validators.required]),
      insuranceName: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      reasonCode: new FormControl('', [Validators.required]),
    });

    this.appealEditForm = new FormGroup({
      activityDate: new FormControl('', [Validators.required]),
      description: new FormControl(''),
      insuranceCode: new FormControl(''),
      insuranceName: new FormControl('', [Validators.required]),
      submissionType: new FormControl('')
    });


    this.payEditForm = new FormGroup({
      provider: new FormControl('', Validators.required),
      policy: new FormControl('', Validators.required),
      group: new FormControl(''),
      admCode: new FormControl(''),
      admName: new FormControl(''),
    });
    this.payEditForm.get('provider').setValue("");
    this.payEditForm.get('policy').setValue("");
    this.payEditForm.get('group').setValue("");
    this.payEditForm.get('admCode').setValue("");
    this.payEditForm.get('admName').setValue("");
    this.billEditForm = new FormGroup({
      isVipRequisition: new FormControl(''),
      isTestRequisition: new FormControl(''),
      isBillingHold: new FormControl(''),
    });
    this.expressPayEditForm = new FormGroup({
      amount: new FormControl('', Validators.required),
      transactionCode: new FormControl('', Validators.required),
      paidDate: new FormControl('', Validators.required),
    });
    this.instBillForm = new FormGroup({
      respParty: new FormControl('', Validators.required),
      amdCode: new FormControl('', Validators.required),
      amdName: new FormControl('', Validators.required),
    });


    this.loadRequisition();
  }

  public loadRequisition() {
    this.loading = true;
    this.billingService.getDetail(this.requisitionId).subscribe((data: any) => {
      this.requisition = data;

      if (!this.requisition.RequisitionBilling) {
        this.requisition.RequisitionBilling = { IsTestRequisition: false, IsVipRequisition: false, IsInstitutionalBill: false, IsExpressPay: false, RequisitionBillingClaims: [], IsBillingOnHold: false, Notes: [] };
        this.requisition.RequisitionBilling.Status = "Pre Billing";
      }

      if (this.requisition.RequisitionBilling.IsInstitutionalBill) {
        this.billingService.getClientInstBillingSettings(this.requisition.ClientId).subscribe((data: any) => {
          this.clientInstBillSettings = data;
          this.enableSendtoAMDButton();
        }, (err) => {
          this.clientInstBillSettings = {};
          this.clientInstBillSettings.ClientId = this.requisition.ClientId;
          this.messageService.add({ severity: 'error', summary: 'Error Loading Client Institutional Billing Settings ', detail: 'Failed: ' + err.error.ExceptionMessage });
        });
      }

      this.genderDescription = this.genderList.find(x => {
        return (x.Code == this.requisition.Gender);
      })?.Description;

      this.ethnicityDescription = this.ethnicityList.find(x => {
        return (x.Code == this.requisition.Ethnicity);
      })?.Description;

      this.raceDescription = this.raceList.find(x => {
        return (x.Code == this.requisition.Race);
      })?.Description;

      this.reqStatusDate = moment(this.requisition.StatusDate).format('MM/DD/YYYY hh:mm:ss A');
      this.reqStatusReceived = moment(this.requisition.DateReceived).format('MM/DD/YYYY hh:mm:ss A');
      this.currentEmail = this.requisition.Email;
      this.currentPhone = this.requisition.Phone;

      this.canUpdate = true;
      this.showSendToADMButton = false;
      this.showExpressPayButton = false;
      this.showBillOptionButton = false;

      if (this.requisition.Status == "Completed"
        && this.requisition.RequisitionBilling.Status == "Pre Billing"
        && this.requisition.RequisitionBilling.IsVipRequisition == false
        && this.requisition.RequisitionBilling.IsTestRequisition == false
      ) {
        this.showSendToADMButton = true;
      }
      if (this.requisition.Status != "Rejected"
        && this.requisition.RequisitionBilling.Status == "Pre Billing"
        && this.requisition.RequisitionBilling.IsInstitutionalBill == false
        && this.requisition.RequisitionBilling.IsVipRequisition == false
        && this.requisition.RequisitionBilling.IsTestRequisition == false) {
        this.showExpressPayButton = true;
      }

      if (this.requisition.RequisitionBilling.Status == 'Claim Paid'
        || this.requisition.RequisitionBilling.Status == 'Sent to ADM'
        || this.requisition.RequisitionBilling.Status == 'Invoice Paid'
        || this.requisition.RequisitionBilling.Status == 'Write Off') {
        this.showBillOptionButton = false;
      } else {
        this.showBillOptionButton = true;
      }

      if (this.requisition.RequisitionBilling.IsInstitutionalBill == true) {
        this.isInsuranceBill = false;
      }
      else if (this.requisition.RequisitionBilling.RequisitionBillingClaims.length == 0) {
        this.isInsuranceBill = true;
      }
      else if (this.requisition.RequisitionBilling.RequisitionBillingClaims.length > 0
        && this.requisition.RequisitionBilling.RequisitionBillingClaims[0].IsPatientPrepaid) {
        this.isInsuranceBill = false;
      }
      else if (this.requisition.RequisitionBilling.RequisitionBillingClaims.length > 0
        && this.requisition.RequisitionBilling.RequisitionBillingClaims[0].IsPatientPrepaid) {
        this.isInsuranceBill = false;
      }
      else if (this.requisition.RequisitionBilling.RequisitionBillingClaims.length > 0
        && this.requisition.RequisitionBilling.RequisitionBillingClaims[0].IsInsuranceBill) {
        this.isInsuranceBill = true;
      }
      else {
        this.isInsuranceBill = true;
      }

      if (this.requisition.RequisitionBilling.Status == 'Claim Denied'
        || this.requisition.RequisitionBilling.Status == 'Claim Response'
        || this.requisition.RequisitionBilling.Status == 'Claim Submitted') {
        this.canSubmitAppeal = true;
      } else {
        this.canSubmitAppeal = false;
      }

      if (this.reload) {
        this.updatedBillingStatus.emit(this.requisition.RequisitionBilling);
        console.log('just emitted ', this.requisition.RequisitionBilling);

        this.reload = false;
      }
      this.enableSendtoAMDButton();

      console.log('requisition ', this.requisition);
      this.loading = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Error Loading Requisition ', detail: 'Failed: ' + err.error.ExceptionMessage });
      this.loading = false;
    });
  }

  sortRequisitionICD(reqICD10s: ReqICD10Dto[]) {
    return reqICD10s.sort((a, b) => {
      if (a.IsQualified > b.IsQualified) {
        return -1;
      }
      if (a.IsQualified < b.IsQualified) {
        return 1;
      }
      if (a.IDC10_Formatted < b.IDC10_Formatted) {
        return -1;
      }
      return 1;
    });
  }

  enableSendtoAMDButton() {
    this.sentToADMErrors = [];
    if (!this.showSendToADMButton) {
      this.enableSendToADMButton = false;
      return;
    }
    if (this.requisition.RequisitionBilling.IsInstitutionalBill) {
      if (this.clientInstBillSettings.InstBillResponsibleParty
        && this.clientInstBillSettings.InstBillProviderCode) {
        this.enableSendToADMButton = true;
        return;
      } else {
        this.sentToADMErrors.push("Institutional Billing is not configured for this client.");
        this.enableSendToADMButton = false;
        return;
      }
    }

    if (this.requisition.RequisitionPays.some(x => x.BillingProviderCode)) {
      this.enableSendToADMButton = true;
      return;
    } else {
      this.sentToADMErrors.push("At least one Insurance Carrier must be assigned.");
      this.enableSendToADMButton = false;
      return;
    }

    this.enableSendToADMButton = false;
  }

  updateOrder() {
    this.loading = true;
    this.requisitionIntakeService.updateOrder(this.requisition.Accession).subscribe((data: any) => {
      if (data) {
        this.reload = true;
        this.loadRequisition();
      }
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Error updating from OrderHub. ', detail: 'Failed: ' + err.error.ExceptionMessage });
      this.loading = false;
    });
  }

  reqRequisitionUpdated() {
    this.editRequisitionFlag = false;
    this.loading = false;
    this.loadRequisition();
    this.messageService.add({ severity: 'success', summary: 'Requisition Updated' });
    this.disableRequisitionEdit = false;
  }
  reqRequisitionUpdateFailed(err) {
    this.messageService.add({ severity: 'error', summary: 'Requisition Update Failed', detail: err });
  }

  cancelEditRequisition() {
    this.editRequisitionFlag = false;
    this.disableRequisitionEdit = false;
  }


  isAdmin(): boolean {
    return this.securityService.hasClaim('LabAdmin_Edit');
  }

  public sendRequisitionToBilling() {
    this.loading = true;
    this.billingService.sendToAdvancedMD(this.requisition.Accession).subscribe((data: any) => {
      if (data) {
        this.messageService.add({ severity: 'success', summary: 'Send To ADM ' + this.requisition.Accession, detail: `Success` });
        this.reload = true;
        this.loadRequisition();
      }
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Unable to Send to AdvancedMD', detail: 'Failed: ' + err.error.ExceptionMessage });
      this.loadRequisition();
    });
  }

  public loadCarriers() {
    this.loading = true;
    this.billingService.getCarriers(this.carrierSearch).subscribe((data: any) => {
      this.carrierCount = data.length;
      this.carriers = data;
      this.loading = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Unable to Load Carriers ', detail: 'Failed: ' + err.error.ExceptionMessage });
      this.carrierCount = 0;
      this.carriers = [];
      this.loading = false;
    });
  }

  public setCarrier(carrier) {
    this.pay.BillingProviderCode = carrier.Code;
    this.pay.BillingProviderName = carrier.Name;
    this.payEditForm.get('admCode').setValue(carrier.Code);
    this.payEditForm.get('admName').setValue(carrier.Name);
    this.payEditForm.markAsDirty();

    this.carrierCount = 0;
    this.carriers = [];
  }


  public showPaymentEdit(p, source) {
    this.pay = p;
    this.payEditForm.get('provider').setValue(this.pay.InsProviderName);
    this.payEditForm.get('policy').setValue(this.pay.Policy);
    this.payEditForm.get('group').setValue(this.pay.Group);
    this.payEditForm.get('admCode').setValue(this.pay.BillingProviderCode);
    this.payEditForm.get('admName').setValue(this.pay.BillingProviderName);

    this.showPaymentDialog = true;
  }

  public savePayment() {
    this.loading = true;
    this.pay.InsProviderName = this.payEditForm.get('provider').value;
    this.pay.Policy = this.payEditForm.get('policy').value;
    this.pay.Group = this.payEditForm.get('group').value;

    this.billingService.updateRequisitionPay(this.pay).subscribe((data: any) => {
      this.messageService.add({ severity: 'success', summary: 'Insurance Carrier Saved', detail: `Carrier [${this.pay.BillingProviderCode}] saved` });
      this.reload = true;
      this.loadRequisition();
      this.showPaymentDialog = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Unable to save Payment ', detail: 'Failed: ' + err.error.ExceptionMessage });
      this.loading = false;
    });
  }

  public cancelPayment() {
    this.showPaymentDialog = false;
  }


  public showBillingEdit() {
    this.billEditForm.get('isVipRequisition').setValue(this.requisition.RequisitionBilling.IsVipRequisition);
    this.billEditForm.get('isTestRequisition').setValue(this.requisition.RequisitionBilling.IsTestRequisition);
    this.billEditForm.get('isBillingHold').setValue(this.requisition.RequisitionBilling.IsBillingOnHold);
    if (this.billingStatusThatCanBeHeld.includes(this.requisition.RequisitionBilling.Status)) {
      this.billEditForm.get('isBillingHold').enable();
    }
    else {
      this.billEditForm.get('isBillingHold').disable();
    }

    this.notes = this.requisition.RequisitionBilling.Notes.map((note) => ({Id: note.Id, NoteDate: new Date(note.NoteDate), Note: note.Note  }));

    this.showBillingDialog = true;
  }

  public saveBilling() {
    this.loading = true;
    this.requisition.RequisitionBilling.IsTestRequisition = this.billEditForm.get('isTestRequisition').value;
    this.requisition.RequisitionBilling.IsVipRequisition = this.billEditForm.get('isVipRequisition').value;
    this.requisition.RequisitionBilling.IsBillingOnHold = this.billEditForm.get('isBillingHold').value;

    this.requisition.RequisitionBilling.Notes = this.notes.map((note) => ({ Id: note.Id, NoteDate: note.NoteDate.toDateString(), Note: note.Note }));

    this.billingService.saveBillingOptions(this.requisition.RequisitionBilling).subscribe((data: any) => {
      this.messageService.add({ severity: 'success', summary: 'Billing Options Updated', detail: `` });
      this.reload = true;
      this.loadRequisition();
      this.showBillingDialog = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Error saving email ', detail: 'Failed: ' + err.error.ExceptionMessage });
      this.loading = false;
    });
  }

  public cancelBilling() {
    this.showBillingDialog = false;
  }
  public showExpressPayEdit() {
    this.loading = true;
    this.expressPayEditForm.get('amount').setValue(1.00);
    this.expressPayEditForm.get('transactionCode').setValue('');
    var d2 = formatDate(new Date(new Date().toLocaleString()), 'yyyy-MM-ddTHH:mm:ss', this.locale);
    this.expressPayEditForm.get('paidDate').setValue(d2);

    this.billingService.getPrepayAmount(this.requisition.LabPanelId).subscribe((data: any) => {
      this.expressPayEditForm.get('amount').setValue(data);
      this.loading = false;
      this.showExpressPayDialog = true;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Unable to retrieve Prepay Amount ', detail: 'Failed: ' + err.error.ExceptionMessage });
      this.loading = false;
      this.showExpressPayDialog = false;
    });
  }

  public saveExpressPay() {
    this.loading = true;
    this.initExpressPayDto();
    this.expressPayDto.RequisitionId = this.requisition.Id;
    this.expressPayDto.Amount = this.expressPayEditForm.get('amount').value;
    this.expressPayDto.TransactionCode = this.expressPayEditForm.get('transactionCode').value;
    this.expressPayDto.PaidDate = this.expressPayEditForm.get('paidDate').value;

    this.billingService.savePrepay(this.expressPayDto).subscribe((data: any) => {
      this.messageService.add({ severity: 'success', summary: 'Prepaid Success', detail: `Saved amount [${this.expressPayDto.Amount}]` });
      this.reload = true;
      this.loadRequisition();
      this.showExpressPayDialog = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Unable to save expressPay Details ', detail: 'Failed: ' + err.error.ExceptionMessage });
      this.loading = false;
    });
  }

  public cancelExpressPay() {
    this.showExpressPayDialog = false;
  }

  dateChanged(eventDate: string): Date | null {
    return !!eventDate ? new Date(eventDate) : null;
  }

  nowhitespace(control: AbstractControl): ValidationErrors | null {
    let str = control.value as string;
    if (str === null) return null;
    if (str.length >= 0 && str.startsWith(' ')) {
      return { nowhitespace: true }
    }
    return null;
  }


  public showEmail() {
    this.currentEmail = this.requisition.Email;
    this.emailEditForm.get('email').setValue(this.requisition.Email);
    this.showEmailDialog = true;
  }

  public saveEmail() {
    this.loading = true;
    this.saveEmailDto = { RequisitionId: this.requisition.Id, Email: this.requisition.Email };

    this.billingService.saveEmail(this.saveEmailDto).subscribe((data: any) => {
      this.messageService.add({ severity: 'success', summary: 'Email Updated', detail: `New email [${this.requisition.Email}]` });
      this.loadRequisition();
      this.showEmailDialog = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Error saving email ', detail: 'Failed: ' + err.error.ExceptionMessage });
      this.loading = false;
    });
  }

  public cancelEmail() {
    this.requisition.Email = this.currentEmail;
    this.showEmailDialog = false;
  }


  public showPhone() {
    this.currentPhone = this.requisition.Phone;
    this.phoneEditForm.get('phone').setValue(this.requisition.Phone);
    this.showPhoneDialog = true;
  }

  public savePhone() {
    this.loading = true;
    this.savePhoneDto = { RequisitionId: this.requisition.Id, Phone: this.requisition.Phone };

    this.billingService.savePhone(this.savePhoneDto).subscribe((data: any) => {
      this.messageService.add({ severity: 'success', summary: 'Phone Updated', detail: `New phone [${this.requisition.Phone}]` });
      this.loadRequisition();
      this.showPhoneDialog = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Error saving phone ', detail: 'Failed: ' + err.error.ExceptionMessage });
      this.loading = false;
    });
  }

  public cancelPhone() {
    this.requisition.Phone = this.currentPhone;
    this.showPhoneDialog = false;
  }


  public showPreAuth() {
    this.currentPreAuth = this.requisition.RequisitionBilling.PreAuthCode;
    this.preAuthEditForm.get('preAuthCode').setValue(this.requisition.RequisitionBilling.PreAuthCode);
    this.showPreAuthDialog = true;
  }

  public savePreAuth() {
    this.loading = true;
    var x = this.preAuthEditForm.get('preAuthCode');
    var code = x.value;
    this.savePreAuthDto = { RequisitionId: this.requisition.Id, PreAuthCode: code };

    this.billingService.savePreAuthCode(this.savePreAuthDto).subscribe((data: any) => {
      this.messageService.add({ severity: 'success', summary: 'PreAuth Code Updated', detail: `New code [${code}]` });
      this.loadRequisition();
      this.showPreAuthDialog = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Error saving PreAuth Code ', detail: 'Failed: ' + err.error.ExceptionMessage });
      this.loading = false;
    });
  }

  public cancelPreAuth() {
    this.requisition.RequisitionBilling.PreAuthCode = this.currentPreAuth;
    this.showPreAuthDialog = false;
  }

  public showInstBillEdit() {
    this.instBillForm.get('respParty').setValue(this.clientInstBillSettings.InstBillResponsibleParty);
    this.instBillForm.get('amdCode').setValue(this.clientInstBillSettings.InstBillProviderCode);
    this.instBillForm.get('amdName').setValue(this.clientInstBillSettings.InstBillProviderName);

    this.showInstBillDialog = true;
  }

  public saveInstBill() {
    this.loading = true;
    this.clientInstBillSettings.InstBillResponsibleParty = this.instBillForm.get('respParty').value;
    this.clientInstBillSettings.InstBillProviderCode = this.instBillForm.get('amdCode').value;
    this.clientInstBillSettings.InstBillProviderName = this.instBillForm.get('amdName').value;

    this.billingService.saveClientInstBillingSettings(this.clientInstBillSettings).subscribe((data: any) => {
      this.messageService.add({ severity: 'success', summary: 'Client Institutional Bill Settings Saved', detail: `Client [${this.requisition.ClientName}] saved` });
      this.enableSendtoAMDButton();
      this.loading = false;
      this.showInstBillDialog = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Unable to save Client Institutional Bill Settings', detail: 'Failed: ' + err.error.ExceptionMessage });
      this.loading = false;
    });
  }

  public setClientCarrier(carrier) {
    this.clientInstBillSettings.InstBillProviderCode = carrier.Code;
    this.clientInstBillSettings.InstBillProviderName = carrier.Name;
    this.instBillForm.get('amdCode').setValue(this.clientInstBillSettings.InstBillProviderCode);
    this.instBillForm.get('amdName').setValue(this.clientInstBillSettings.InstBillProviderName);
    this.instBillForm.markAsDirty();

    this.carrierCount = 0;
    this.carriers = [];
  }

  public cancelInstBill() {
    this.showInstBillDialog = false;
  }


  public showAppealEdit(rbcl: ReqBillingClaimLogDto) {
    if (this.requisition.RequisitionBilling.RequisitionBillingClaims[0].RequisitionBillingClaimLogs.length > 0) {
      const sortedItems = this.requisition.RequisitionBilling.RequisitionBillingClaims[0].RequisitionBillingClaimLogs.slice().sort((a, b) => new Date(b.ActivityDate).getTime() - new Date(a.ActivityDate).getTime());
      const latestItem = sortedItems[0];
      this.minAppealDate = new Date(latestItem.ActivityDate);
      this.lastInsuranceCode = latestItem.InsuranceCode;
      this.lastInsuranceName = latestItem.InsuranceName;
    } else {
      this.minAppealDate = new Date("2026-01-01");
      this.lastInsuranceCode = "";
      this.lastInsuranceName = "";
    }

    this.appealEditForm.get('activityDate').setValue("");
    this.appealEditForm.get('submissionType').setValue('');
    this.appealEditForm.get('description').setValue('');
    this.appealEditForm.get('insuranceCode').setValue(this.lastInsuranceCode);
    this.appealEditForm.get('insuranceName').setValue(this.lastInsuranceName);
    

    if (rbcl) {
      this.appealEditForm.get('activityDate').setValue(rbcl.ActivityDate);
      this.appealEditForm.get('description').setValue('');
    }
    this.showAppealDialog = true;
  }

  public saveAppeal() {
    this.loading = true;
    this.saveClaimSubmissionDto = {
      RequisitionId: this.requisition.Id,
      CPT: this.requisition.RequisitionBilling.RequisitionBillingClaims[0].CPT,
      ActivityDate: "",
      SubmissionType: "",
      Description: "",
      InsuranceProviderCode: "",
      InsuranceProviderName: "",
    };

    this.saveClaimSubmissionDto.ActivityDate = this.appealEditForm.get('activityDate').value;
    this.saveClaimSubmissionDto.SubmissionType = this.appealEditForm.get('submissionType').value;
    this.saveClaimSubmissionDto.Description = this.appealEditForm.get('description').value;
    this.saveClaimSubmissionDto.InsuranceProviderCode = this.appealEditForm.get('insuranceCode').value;
    this.saveClaimSubmissionDto.InsuranceProviderName = this.appealEditForm.get('insuranceName').value;

    this.billingService.saveClaimSubmission(this.saveClaimSubmissionDto).subscribe((data: any) => {
      this.messageService.add({ severity: 'success', summary: 'Appeal Submission recorded', detail: `New code` });
      this.loadRequisition();
      this.showAppealDialog = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Error saving Appeal Submission ', detail: 'Failed: ' + err.error.ExceptionMessage , sticky: true});
      this.loading = false;
    });
  }

  public cancelAppealEdit() {
    this.requisition.RequisitionBilling.PreAuthCode = this.currentPreAuth;
    this.showAppealDialog = false;
  }



  public showClaimLog(rbcl: ReqBillingClaimLogDto) {
    if (rbcl) {
      this.claimLogEditForm.get('activityCode').setValue(rbcl.ActivityCode);
      this.claimLogEditForm.get('activity').setValue(rbcl.Activity);
      this.claimLogEditForm.get('activityDate').setValue(rbcl.ActivityDate);
      this.claimLogEditForm.get('insuranceCode').setValue(rbcl.InsuranceCode);
      this.claimLogEditForm.get('reasonCode').setValue(rbcl.ReasonCode);
    }
    this.showClaimLogDialog = true;
  }

  public saveClaimLog() {
    this.loading = true;
    var x = this.claimLogEditForm.get('preAuthCode');
    var code = x.value;
    this.savePreAuthDto = { RequisitionId: this.requisition.Id, PreAuthCode: code };

    this.billingService.savePreAuthCode(this.savePreAuthDto).subscribe((data: any) => {
      this.messageService.add({ severity: 'success', summary: 'PreAuth Code Updated', detail: `New code [${code}]` });
      this.loadRequisition();
      this.showClaimLogDialog = false;
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Error saving PreAuth Code ', detail: 'Failed: ' + err.error.ExceptionMessage });
      this.loading = false;
    });
  }

  public cancelClaimLog() {
    this.requisition.RequisitionBilling.PreAuthCode = this.currentPreAuth;
    this.showClaimLogDialog = false;
  }


  initExpressPayDto() {
    this.expressPayDto = {
      RequisitionId: this.requisition.Id,
      Amount: 299.99,
      PaidDate: new Date().toDateString(),
      TransactionCode: ''
    }
  }

  public onRowEditInit(tutorial: BillingNote, index: number) {
    this.editingRowKeys = {};
    this.editingRow = true;

    this.editingRowKeys[tutorial.Id] = true;
    this.clonedNotes[index] = { ...this.notes[index] };
  }

  public onDeleteRowClick(tutorial: BillingNote, index: number) {
    this.editingRow = true;
    this.notes.splice(index, 1);
    this.editingRowKeys = {};
    this.editingRow = false;
  }

  public onInsertRowClick() {
    this.editingRow = true;
    var newId = Math.max(...this.notes.map(note => note.Id)) + 1;
    var newNote: BillingNote = { Id: newId, NoteDate: new Date(), Note: 'new note...' };
    this.notes = [...this.notes, newNote];
    this.editingRow = false;
  }

  public onRowEditSave(tutorial: BillingNote, index: number) {
    delete this.clonedNotes[index];
    this.editingRow = false;
  }

  public onRowEditCancel(tutorial: BillingNote, index: number) {
    this.notes[index] = this.clonedNotes[index];
    delete this.clonedNotes[index];
    this.editingRow = false;
  }

  public getResultReport() {
    this.loading = true;
    this.billingService.getResultReportByAccession(this.requisition.Accession).subscribe((response: any) => {
      this.loading = false;
      if (response) {
        let file = new Blob([response], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'PDF is not available' });
      }
    }, (err) => {
      this.loading = false;
      this.messageService.add({ severity: 'error', summary: 'Unable to retrieve Report PDF ', detail: 'Failed: ' + err.error });
    });
  }

  public getRequisitionDoc() {
    if (this.requisition === null) return;
    this.loading = true;
    this.medtek21Service.getRequisitionByAccession(this.requisition.Accession).subscribe((response: any) => {
      this.loading = false;
      if (response) {

        let file = new Blob([response], { type: 'application/pdf' });

        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
    }, (err) => {
      this.loading = false;
      this.messageService.add({ severity: 'error', summary: 'Unable to retrieve requisition PDF ', detail: 'Failed: ' + err.error });
    });
  }


  public getClaimReport() {
    this.loading = true;
    this.billingService.getReportXLSX(this.requisition.Accession).subscribe((response: any) => {
      this.loading = false;
      if (response) {
        let file = new Blob([response], { type: 'application/xslx' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'XSLX is not available' });
      }
    }, (err) => {
      this.loading = false;
      this.messageService.add({ severity: 'error', summary: 'Unable to retrieve Report ', detail: 'Failed: ' + err.error });
    });
  }


}
export interface BillingNote {
  Id?: number;
  NoteDate?: Date;
  Note?: string;
}
